import { render } from "./MyPageAuth2.vue?vue&type=template&id=54377653&scoped=true&ts=true"
import script from "./MyPageAuth2.vue?vue&type=script&lang=ts"
export * from "./MyPageAuth2.vue?vue&type=script&lang=ts"

import "./MyPageAuth2.vue?vue&type=style&index=0&id=54377653&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54377653"]])

export default __exports__